import Contact from './Contact.vue';

const routes = [
  {
    path      : '/contact',
    name      : 'Contact',
    component : Contact,
    meta      : {
      isPublic: true
    }
  }
];

export default routes;
